import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import Input from 'components/Kizen/Input';

export const StyledInput = styled(Input)`
  margin-top: ${gutters.spacing(4)}px;
`;
